import Button from './Button';
import IconButton from './IconButton';
import Link from './Link';
import Badge from './Badge';
import Input from './Input';
import Tabs from './Tabs';
import Table from './Table';
import Accordian from './Accordian';
import Switch from './Switch';
import ToggleButtonGroup from './ToggleButtonGroup';

import MuiCssBaseline from './MuiCssBaseline';

export default {
  ...Button,
  ...IconButton,
  ...Link,
  ...Badge,
  ...Input,
  ...Tabs,
  ...Table,
  ...Accordian,
  ...MuiCssBaseline,
  ...Switch,
  ...ToggleButtonGroup,
};



// WEBPACK FOOTER //
// ./src/layouts/ThemeProvider/overrides/index.js